export const optionCompressImage = {
  maxSizeMB: 0.7,
  maxWidthOrHeight: 1024,
  useWebWorker: true,
};

export const ADMIN = "ADMIN";
